import React, { Children } from 'react';
import isArray from 'lodash/isArray';

/**
 * Add any React, JSX, etc utilities here
 */

/**
 * Get display name of a component
 * @param {Object} Comp Component
 * @return {String} Display name of Component
 */
export const getDisplayName = (Comp) => {
    if (!Comp) {
        return '';
    }

    if (typeof Comp === 'string') {
        return Comp;
    }

    return Comp.displayName || Comp.name || 'Component';
}
/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */
export const findAllByType = (children, type) => {
    const result = [];
    let types = [];

    if (isArray(type)) {
        types = type.map(t => getDisplayName(t));
    } else {
        types = [getDisplayName(type)];
    }

    React.Children.forEach(children, (child) => {
        const childType = child && child.type && (child.type.displayName || child.type.name);
        if (types.indexOf(childType) !== -1) {
            result.push(child);
        }
    });

    return result;
};

/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */
export const findChildByType = (children, type) => {
    const result = findAllByType(children, type);

    return result && result[0];
};

/**
 * Get a child by index
 * @param {any} children
 * @param {any} index
 */
export const findChildByIndex = (children, index) => {
    const childrenArray = React.Children.toArray(children);

    return childrenArray[index] || null;
}

export const findChildByPropValue = (children, propName, value) => {
    const result = [];

    React.Children.forEach(children, (child) => {
        if (child.props.hasOwnProperty(propName) && child.props[propName] === value) {
            result.push(child);
        }
    });

    return result && result[0];
}